import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-excludesquare",
  "use": "icon-th-excludesquare-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-excludesquare\">\n<path d=\"M28 20V12C28 11.7348 27.8946 11.4804 27.7071 11.2929C27.5196 11.1054 27.2652 11 27 11H21V5C21 4.73478 20.8946 4.48043 20.7071 4.29289C20.5196 4.10536 20.2652 4 20 4H5C4.73478 4 4.48043 4.10536 4.29289 4.29289C4.10536 4.48043 4 4.73478 4 5V12V20C4 20.2652 4.10536 20.5196 4.29289 20.7071C4.48043 20.8946 4.73478 21 5 21H11V27C11 27.2652 11.1054 27.5196 11.2929 27.7071C11.4804 27.8946 11.7348 28 12 28H27C27.2652 28 27.5196 27.8946 27.7071 27.7071C27.8946 27.5196 28 27.2652 28 27V20ZM20.4137 26L15.4137 21H19.5863L24.5863 26H20.4137ZM6 7.41375L11 12.4137V16.5863L6 11.5863V7.41375ZM11.5863 6L16.5863 11H12.4137L7.41375 6H11.5863ZM13 19V13H19V19H13ZM21 19.5863V15.4137L26 20.4137V24.5863L21 19.5863ZM26 17.5863L21.4137 13H26V17.5863ZM19 10.5863L14.4137 6H19V10.5863ZM6 14.4137L10.5863 19H6V14.4137ZM13 21.4137L17.5863 26H13V21.4137Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-excludesquare.svg
// module id = /6LB
// module chunks = 84